import { BridgeFormJSState, DEFAULT_STATE } from '../Types';
import { getParamFromSchema } from './ParamFromSchema';
import { ParamModel } from './ParamModelTypes';
import { ParamSchema } from './ParamSchemaTypes';
import { getModelFromGroupParam } from './ParamToModel';

export const paramModelSelector = (state: BridgeFormJSState): ParamModel =>
  getModelFromGroupParam('form', state);

export const paramPreloadedState = (
  schema: ParamSchema[],
  model: ParamModel
): BridgeFormJSState =>
  schema.reduce(getParamFromSchema('form', model), DEFAULT_STATE);
